// Stores
import { useResult } from "../../../../shared/formContext/hooks/useResult";

// Components
import Table from "../../../../components/Table/Table";
import IconContent from "../../../../components/IconContent/IconContent";
import Cta from "../../../../components/Cta/Cta";
import Box from "../../../../components/Box/Box.js";

// Helpers
import { utils } from "../../../../helpers/index.js";

// React
import { useState, useEffect } from "react";

// Internacionalization
import { __ } from "@wordpress/i18n";


const PropertyValuation: React.FC = () => {
    const { resultData } = useResult();
    const { response, loading } = resultData;
    const [topBox, setTopBox] = useState<{ title: string; info: string; color: string; content: any } | null>(null);
    const [tableData, setTableData] = useState<Array<Array<{ value: string; className?: string }>> | null>(null);

    useEffect(() => {
        if (response) {
          const predict = response.data?.result?.predict;

          if (!predict || !predict.avg) {
            console.warn(__("Prediction data not found in API response", "dfs-simulators"));
            return;
          }

          const title = __("O valor estimado do imóvel é de:", "dfs-simulators");
          const info = utils.toEuro(predict.avg.gross);
          const color = "orange-100";

          setTopBox({
            title,
            info,
            color,
            content: { predict },
          });

          setTableData([
            [
              { value: __("Valor mínimo", "dfs-simulators"), className: "text-left" },
              { value: utils.toEuro(predict.min.gross) },
              { value: utils.toEuro(predict.min.perSq) },
            ],
            [
              { value: __("Valor médio", "dfs-simulators"), className: "text-left bold" },
              { value: utils.toEuro(predict.avg.gross), className: "bold" },
              { value: utils.toEuro(predict.avg.perSq), className: "bold" },
            ],
            [
              { value: __("Valor máximo", "dfs-simulators"), className: "text-left" },
              { value: utils.toEuro(predict.max.gross) },
              { value: utils.toEuro(predict.max.perSq) },
            ],
          ]);
        }
      }, [response]);

    return (
        <div className="property-valuation-proptech">
            {topBox && (
                <Box
                    grid
                    loading={loading}
                    header={{ title: topBox.title, info: topBox.info, color: topBox.color }}
                >
                    <IconContent
                        title={__("Custo médio por m² deste imóvel:", "dfs-simulators")}
                        color={topBox.color}
                        bigText={`${utils.toEuro(topBox.content.predict.avg.perSq)} /m²`}
                    />

                    <IconContent
                        title={__("Valor mínimo que deve considerar:", "dfs-simulators")}
                        color={topBox.color}
                        bigText={utils.toEuro(topBox.content.predict.min.gross)}
                    />

                    <IconContent
                        title={__("Valor máximo que deve considerar:", "dfs-simulators")}
                        color={topBox.color}
                        bigText={utils.toEuro(topBox.content.predict.max.gross)}
                    />
                </Box>
            )}

            {tableData && (
                <Box
                    header={{ title: __("Intervalo de preços", "dfs-simulators") }}
                    textColor="navy-100"
                    loading={loading}
                >
                    <Table
                        headers={[
                            { value: " ", className: "text-left" },
                            { value: __("Valor imóvel", "dfs-simulators") },
                            { value: __("Valor por m²", "dfs-simulators") },
                        ]}
                        data={tableData}
                    />
                </Box>
            )}
                <Box
                    backgroundColor="navy-5"
                    textColor="navy-70"
                    vertical
                    header={{ title: __("Notas", "dfs-simulators"), textColor: "navy-70" }}
                >
                <IconContent

                    text={__(
                        "<ul><li>Os valores são indicativos, com base em transações reais com as mesmas características e localização;</li><li>Este simulador permite 5 simulações por sessão.</li></ul>",
                        "dfs-simulators"
                    )}
                    color="navy-70"
                    textColor="navy-70"
                    className="alfredo-text"
                />
            </Box>

            <Cta/>
        </div>
    );
};

export default PropertyValuation;
